export default {
  getRemDivisionList: state => state.remDivisionList,
};



// WEBPACK FOOTER //
// ./src/vuex/rem/division/divisionGetters.js